import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import {APP_INITIALIZER, LOCALE_ID, NgModule} from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';
import localeRuExtra from '@angular/common/locales/extra/ru';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AuthInterceptor, EncodeHttpParamsInterceptor } from '@lib/interceptors';
import { WebsocketInitializer, WebsocketService } from '@lib/services';
import { CustomMatIconInitializer } from '@lib/services/custom-mat-icons';
import { MessengerModule } from 'winsolutions-messenger';
import {MatNativeDateModule} from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getRuPaginatorIntl } from '@core/const/mat-paginator-intl';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmDialogModule } from '@ui/modules/confirm-dialog/confirm-dialog.module';
import { AccessDirective } from '@ui/directives/access/access.directive';
import {AppInitializer} from "@app/app-initializer";

export function loadApp(initializer: AppInitializer) {
  return () => initializer.load();
}

registerLocaleData(localeRu, 'ru-RU', localeRuExtra);
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatSnackBarModule,
    MessengerModule,
    MatNativeDateModule,
    MatDialogModule,
    ConfirmDialogModule
  ],
  providers: [
    CustomMatIconInitializer,
    AuthInterceptor,
    {
      provide: MatPaginatorIntl,
      useValue: getRuPaginatorIntl()
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EncodeHttpParamsInterceptor,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'ru-RU' },
    WebsocketService,
    WebsocketInitializer,
    AppInitializer,
    {
      provide: APP_INITIALIZER,
      useFactory: loadApp,
      multi: true,
      deps: [AppInitializer]
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
